<div class="container">
  <div class="row">
    <div class="col-12 d-flex justify-content-center">
      <div class="spinner-border ap-text-green" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</div>
